import PropTypes from 'prop-types';
import React from 'react';

export class PropertyView extends React.Component {
  componentDidMount() {
    const { handleHeaderDisplay } = this.props;
    if (handleHeaderDisplay && this.hasValue()) {
      this.props.handleHeaderDisplay(true);
    }
  }

  hasValue() {
    const { value } = this.props;
    return !(value === null || value === '' || value === undefined || value === 'null' || value === 'undefined');
  }

  render() {
    const { label, value, qaTag } = this.props;
    return (
      this.hasValue() ?
        <div>
          <div data-qa-item={ qaTag }>
            <label className='bold'> { label }:&nbsp;</label>
            {value}
          </div>
        </div>
        :
        null
    );
  }
}

PropertyView.propTypes = {
  label: PropTypes.any,
  value: PropTypes.string,
  qaTag: PropTypes.string,
  handleHeaderDisplay: PropTypes.func,
};
